import { createClient } from "contentful";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const client = createClient(config.public.ctf);

  return {
    provide: {
      contentfulClient: client,
    },
  };
});
